import {
    SET_KEYWORD_ACCOR
} from '../../actions';

const initialState = {
    boolean: true
}

function keywordAccordReducer(state = initialState, action ) {
    const newState = {};

    switch (action.type) {
        case SET_KEYWORD_ACCOR:
            newState.boolean = action.status;
            return newState;
        
        default:
            return state;

    }
}

export default keywordAccordReducer;
